import React, { useState } from 'react';


const FlashcardView = ({ data }) => {
    // Ensure we have an array of cards
    const cards = Array.isArray(data) ? data : (data ? [data] : []);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFlipped, setIsFlipped] = useState(false);

    if (cards.length === 0) {
        return <div className="p-4 text-center text-gray-500">Nessuna card disponibile.</div>;
    }

    const currentCard = cards[currentIndex];

    const nextCard = () => {
        setIsFlipped(false);
        setTimeout(() => {
            setCurrentIndex((prev) => (prev + 1) % cards.length);
        }, 200);
    };

    return (
        <div className="flex flex-col items-center justify-center h-full p-4 bg-slate-50">
            <div className="w-full max-w-md mb-4 flex justify-between items-center text-slate-500 text-xs font-bold uppercase tracking-wider">
                <span>Card {currentIndex + 1} di {cards.length}</span>
                <span>Tap per girare</span>
            </div>

            <div
                className="relative w-full max-w-md h-72 cursor-pointer group perspective-1000"
                onClick={() => setIsFlipped(!isFlipped)}
                style={{ perspective: '1000px' }}
            >
                <div
                    className="relative w-full h-full transition-transform duration-500"
                    style={{
                        transformStyle: 'preserve-3d',
                        transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
                    }}
                >
                    {/* Fronte */}
                    <div
                        className="absolute w-full h-full bg-white border border-slate-200 rounded-3xl shadow-xl flex flex-col items-center justify-center p-8 text-center hover:shadow-2xl transition-shadow"
                        style={{
                            backfaceVisibility: 'hidden',
                            WebkitBackfaceVisibility: 'hidden', // Supporto Safari
                            zIndex: isFlipped ? 0 : 1 // Forza visibilità
                        }}
                    >
                        {/* Titolo della Card */}
                        <div className="absolute top-6 left-0 w-full px-8 flex justify-center">
                            <span className="bg-indigo-50 text-indigo-600 text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wide">
                                {currentCard.title || 'Flashcard'}
                            </span>
                        </div>

                        <h3 className="text-xl font-semibold text-slate-800 leading-snug">{currentCard.front}</h3>
                    </div>

                    {/* Retro */}
                    <div
                        className="absolute w-full h-full bg-indigo-600 rounded-3xl shadow-xl flex flex-col items-center justify-center p-8 text-center text-white"
                        style={{
                            backfaceVisibility: 'hidden',
                            WebkitBackfaceVisibility: 'hidden', // Supporto Safari
                            transform: 'rotateY(180deg)',
                            zIndex: isFlipped ? 1 : 0
                        }}
                    >
                        <span className="text-xs font-bold text-indigo-200 uppercase tracking-widest mb-4">Risposta</span>
                        <p className="text-lg leading-relaxed font-medium">{currentCard.back}</p>
                    </div>
                </div>
            </div>

            <div className="mt-8 flex gap-4">
                <button onClick={nextCard} className="px-8 py-3 bg-white border border-slate-200 shadow-sm hover:shadow-md hover:bg-slate-50 rounded-full text-slate-700 font-bold transition-all flex items-center gap-2">
                    Prossima <span className="text-indigo-500">→</span>
                </button>
            </div>

        </div>
    );
};

export default FlashcardView;
